<template>
  <v-dialog id="qMsgbox" scrollable persistent v-model="dialog_show" max-width="600px" style="z-index: 2147483648;">  
    <v-card>
      <v-toolbar color="primary" height="40px;" dark>{{PopTitle}}</v-toolbar>
      <v-card-text>
        {{PopContent}}
      </v-card-text>
      <v-card-actions style="justify-content:space-evenly">
        <v-btn color="primary" @click="btnOK" v-on:keyup.enter="btnOK" v-on:keyup.esc="btnOK" v-if="IsShowOk">Ok</v-btn>
        <v-btn color="primary" @click="btnYes" v-on:keyup.enter="btnYes" v-if="IsShowYes">Yes</v-btn>
        <v-btn color="primary" @click="btnNo" v-on:keyup.esc="btnNo" v-if="IsShowNo">No</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default { 
    name:'qMsgbox',
    data() {
      return {
        PopTitle :'',
        PopContent :'',
        PopButtonType :'',
        IsShowOk :false,
        IsShowYes :false,
        IsShowNo :false,
        dialog_show:false, // 팝업 활성화 여부 (Mobile)
        ParentCallBack:null,
      }
    },
    created() {
        
    },
    mounted() {
        this.SetButton();
    },
    methods: {
        show(title, msg, type, callback) {
          this.PopTitle = title;
          this.PopContent = msg;
          this.PopButtonType = type;
          this.SetButton();
          this.dialog_show=true;
          this.ParentCallBack = callback
        },
        SetButton() {
          if(this.PopButtonType == undefined || this.PopButtonType.length <= 0)
              return;

          this.IsShowOk = false;
          this.IsShowYes = false;
          this.IsShowNo = false;

          this.PopButtonType.forEach(element => {
              if(element.toUpperCase() == "OK") {
                  this.IsShowOk = true;
              } 
              else if(element.toUpperCase() == "YES") {
                  this.IsShowYes = true;
              }
              else if(element.toUpperCase() == "NO") {
                  this.IsShowNo = true;
              }
          });
        },
        btnOK() {
          this.close(true);
        },
        btnYes() {
          this.close(true);
        },
        btnNo() {
          this.close(false);
        },
        close(result) {
          this.dialog_show = false;
          this.ParentCallBack(result)
        }
    }
}

</script>
<style scoped>
  .v-dialog > .v-card > .v-card__text {
    padding:16px;
  }
</style>